module.exports = __webpack_public_path__ + "static/img/coupon_three.2eeed7d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/coupon_three.png
// module id = UD7W
// module chunks = 0